import { fetchProcessingFactoryList } from '#/api/momMgmt/settings/processingFactory/fetchList';
import { fetchProcessingFactoryDetail } from '#/api/momMgmt/settings/processingFactory/fetchDetail';
import { coerceFilterValues } from '#/modules/commonComponents/table/columnFilterUtils';

export function mapProcessingFactoryRowsToSelectOptions(rows = []) {
  return rows.map((row) => ({
    value: row.id,
    label: [row.code, row.name].filter(Boolean).join(' ') || String(row.id),
  }));
}

/**
 * ACTIVE 加工廠 select options（工單表單等）。
 * 使用 lookupQueryKey('processingFactorySelect')。
 */
export async function fetchProcessingFactorySelectOptions() {
  const { data } = await fetchProcessingFactoryList({
    page: 1,
    pageSize: 200,
    keyword: '',
    sort: [],
    filters: { status: 'ACTIVE' },
  });

  return mapProcessingFactoryRowsToSelectOptions(data ?? []);
}

/** 列表 async filter：關鍵字搜尋加工廠。 */
export async function searchProcessingFactoryFilterOptions({ keyword }) {
  const result = await fetchProcessingFactoryList({
    page: 1,
    pageSize: 20,
    keyword: keyword ?? '',
    filters: {},
    sort: [],
  });

  return mapProcessingFactoryRowsToSelectOptions(result.data ?? []);
}

/**
 * URL 已有 processingFactoryId 但 label cache 空時，依 id 補 label。
 * @returns {Promise<boolean>} 是否有寫入新 label
 */
export async function hydrateProcessingFactoryFilterLabels(ids, labelCache) {
  if (!labelCache) {
    return false;
  }

  const missing = coerceFilterValues(ids).filter((id) => !labelCache.has(String(id)));
  if (missing.length === 0) {
    return false;
  }

  await Promise.all(missing.map(async (id) => {
    try {
      const result = await fetchProcessingFactoryDetail(id);
      const row = result?.data;
      if (!row) {
        return;
      }
      const label = [row.code, row.name].filter(Boolean).join(' ') || String(id);
      labelCache.set(String(id), label);
    } catch {
      // unresolved → ListFilterStatus 顯示「已選 N 項」
    }
  }));

  return missing.some((id) => labelCache.has(String(id)));
}
